<template>
  <div class="form-group esma_form_group">
    <label  v-if="showLabel" v-bind:for="fieldID" class="col-xs-4 control-label esma_form_label">{{fieldLabel}}</label>
    <div :class="fieldClass" style="padding:1px 0px 1px 7px;">
      <datetimepicker 
       :disabled-picker="isDisabled" 
       :disabled="isDisabled" 
       :input-style="disabledStyle +';height: 24px!important;'+ filedStyle"
       :input-button-style="buttonStyle"
      input-class=" form-control force-white"
      v-on:input="updateValue"
      :id="fieldID"  
      :name="fieldID"  
      :value="fieldValue" 
      placeholder=""
      calendar-style="left:-100px;"
      ></datetimepicker>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
//import Datetimepicker from 'vuejs-datetimepicker';
//https://github.com/charliekassel/vuejs-datetimepicker
import Datetimepicker from '../dp/Datetimepicker2';

Vue.component('datetimepicker', Datetimepicker);
import debug from 'debug';
import moment from 'moment';
var debug_date_box = debug('esma:date_box');
export default {
  data() {
    return {
      count: 0
    };
  },
  methods: {
    updateValue(d) {
      debug_date_box('SET DATE', this.fieldID, d, this.$props.value);
      if (d == null) {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = null;
      } else {
        this.$store.state[this.stateCurrentEditing][this.fieldID] = moment(d).format("YYYY-MM-DD HH:mm:ss");
      }

    },
    getOption(name, def) {
      if (typeof this.$props.option[name] == 'undefined') {
        return def;
      }
      return this.$props.option[name];
    }
  },
  computed: {
    filedStyle() {
      var store_style = this.$store.state[this.stateCurrentRow.replace("current_row","current_field_style")][this.fieldID] || "";
      return (this.$props.data.field_style || "") + store_style;
    },
    stateCurrentRow(){
      if(typeof this.$props.data.state_current_row != "undefined"){
        return this.$props.data.state_current_row;
      }else{
        return "current_row";
      }
    },
    stateCurrentEditing(){
      if(typeof this.$props.data.state_current_editing != "undefined"){
        return this.$props.data.state_current_editing;
      }else{
        return "current_editing";
      }
    },
    stateIsEditingNew(){
      if(typeof this.$props.data.state_is_editing_new != "undefined"){
        return this.$props.data.state_is_editing_new;
      }else{
        return "is_editing_new";
      }
    },
    seqId() {
      return this.$props.data.seq_id;
    },
    bootstrapStylingTrue() {
      return true;
    },
    fieldLabel() {
      return this.$props.data.label;
    },
    fieldClass() {
      if (this.getOption('hide_label', false) == true) {
        return 'col-xs-12';
      } else {
        return 'col-xs-8';
      }
    },
    showLabel() {
      if (this.getOption('hide_label', false) == true) {
        return false;
      } else {
        return true;
      }
    },
    fieldValue() {
      debug_date_box('fieldValue');

      if (this.$store.state[this.stateCurrentRow][this.fieldID] == null) {
        this.count++;
        if (this.count > 2000) {
          this.count = 0;
        }
        debug_date_box('fieldValue return 1');
        return null;//3000 + this.count + '-01-01';
      } else {
        debug_date_box('fieldValue return 2 ', this.$store.state[this.stateCurrentRow][this.fieldID]);
        return moment(this.$store.state[this.stateCurrentRow][this.fieldID]).format("YYYY/MM/DD HH:mm");
      }
    },
    fieldID() {
      return this.$props.data.id;
    },
    fieldTableName() {
      return this.$props.data.table_name;
    },
    disabledStyle() {
      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
      }
      return this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
    },
    buttonStyle() {
      if (this.$store.state[this.stateIsEditingNew] == true) {
        debug_date_box('buttonStyle is_editing_new', typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined');
        return;
        typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
      }
      debug_date_box('buttonStyle ', this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined');
      return this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined' ? 'background-color: #cccccc;' : 'background-color: white;';
    },
    isDisabled() {
      debug_date_box("isDisabled");
      if (this.$store.state[this.stateIsEditingNew] == true) {
        return this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined'; //TODO, can also has another field to force it.
      }
      return this.$props.data.disabled || this.$props.read || typeof this.$store.state[this.stateCurrentRow][this.fieldID] == 'undefined';

    }
  },
  props: ['data', 'value', 'option', 'read'],
   mounted(){
     this.$props.data.ref_field = this;
  },
};
</script>
<style scoped>
.form-control[readonly].force_white {
  background-color: white;
  opacity: 1;
}
.form-control[disabled],
fieldset[disabled] .form-control {
  background-color: white;
}
.form-control {
  color: black;
  height: 24px;
  height: 24px!important;
}
.form-control::selection {
  color: white;
  background: #575757;
}
</style>


// WEBPACK FOOTER //
// datetime-box.vue?4e23afd5